import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=2114ab6e&scoped=true"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"
import style0 from "./CoursesList.vue?vue&type=style&index=0&id=2114ab6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2114ab6e",
  null
  
)

export default component.exports